import { delRelease, getSetsList } from "@/pages/Space/api/mySpace";
import React, { useEffect, useMemo, useState } from "react";
import { useAsyncEffect, useMount } from "ahooks";
import { mySpaceStore } from "@/stores/mySpace";
import styles from "./index.module.scss";
import { ImgAndPromptItemType } from "@/stores/gallery";
import { observer } from "mobx-react-lite";
import { Sets } from "@/types/mySpace";
import PubItem from "../PubItem";
import useColumn from "../../hook/useColumn";
import GalleryDetail from "@/pages/Gallery/components/GalleryDetail";
import { cloneDeep } from "lodash";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import { loginStore } from "@/modules/login/store";
import { changeURLParam, urlQueryParser } from "@/utils/tool";
import { getPromptDetail, postOpusDetail } from "@/pages/Gallery/api";
import { mySpaceOpusDetail } from "@/components/bussiness/StationMessage/api";
import EmptyContent from "../EmptyContent";

const PAGE_NUM = 20;

const Publish: React.FC = () => {
  const [curIdx, setCurIdx] = useState<number>(1);
  const [dataList, setDataList] = useState<Sets[]>([]);
  const [noMore, setNoMore] = useState<boolean>(false);
  const [detailVisible, setDetailVisible] = useState<boolean>(false);
  const [currentOpusId, setCurrentOpusId] = useState<string | number>("");
  const [currentImgId, setCurrentImgId] = useState<string | number>("");
  const [curActiveItemIdx, setCurActiveItemIx] = useState<null | number>(null);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const [curDetailInfo, setCurDetailInfo] = useState<ImgAndPromptItemType[]>([]);
  const [curDelItemInfo, setCurDelItemInfo] = useState<{
    id: number;
    idx: number;
  } | null>(null);

  const parseIds = (ids: string | number) => {
    const res = {
      opusId: "0",
      imgId: "0",
    };
    const splitIds = String(ids).split("-");
    res.opusId = splitIds[0] || "0";
    res.imgId = splitIds[1] || "0";
    return res;
  };

  useAsyncEffect(async () => {
    const { viewDetail } = urlQueryParser(location.href);
    const { opusId, imgId } = parseIds(viewDetail);
    if (viewDetail) {
      setCurrentOpusId(opusId);
      setCurrentImgId(imgId);
      setDetailVisible(true);
      const url = changeURLParam(location.href, "viewDetail", ""); // 修改 URL 参数
      history.replaceState(null, null as any, url); // 替换地址栏
    }
  }, []);

  useAsyncEffect(async () => {
    await getList(curIdx);
    if (firstLoad) setFirstLoad(false);
  }, []);

  const cancelRef = React.useRef();
  const column = useColumn();
  const info = loginStore.userState.userInfo;

  const localDelete = (idx: number) => {
    const newList = [...dataList];
    newList.splice(idx, 1);
    setDataList(newList);
  };

  const getList = async (pageIndex: number) => {
    mySpaceStore.setLoading(true);
    const res = await getSetsList({
      page_index: pageIndex,
      page_size: PAGE_NUM,
      user_id: Number(info.userId),
    });
    if (res.code == 0 && res.data) {
      setDataList([...dataList, ...res.data.opus]);
      setCurIdx(pageIndex + 1);
      setNoMore(pageIndex * PAGE_NUM >= res.data.total);
      mySpaceStore.setLoading(false);
    }
  };

  // const curDetailInfo = useMemo(() => {
  //   let res: ImgAndPromptItemType[] = [];
  //   if (curActiveItemIdx !== null) res = dataList[curActiveItemIdx].opus_image;
  //   return res;
  // }, [curActiveItemIdx, dataList]);

  const handleDetailClose = async () => {
    const res = await mySpaceOpusDetail({ opus_id: Number(currentOpusId) });
    if (res.code === 0 && res.data && curActiveItemIdx !== null) {
      const newDataList = cloneDeep(dataList);
      newDataList[curActiveItemIdx] = res.data;
      setDataList(newDataList);
    }
    setDetailVisible(false);
  };

  const handleLoadMore = () => {
    getList(curIdx);
  };

  const handleDetailLike = (id: number) => {
    if (curActiveItemIdx === null) return;
    const newDataList = cloneDeep(dataList);
    const newItem = newDataList[curActiveItemIdx];
    newItem.like += 1;
    const newImgs = cloneDeep(newItem.opus_image);
    const imgIdx = newImgs.findIndex((item) => String(item.image_id) == String(id));
    newImgs[imgIdx].likes! += 1;
    newImgs[imgIdx].is_like = true;
    newItem.opus_image = newImgs;
    setDataList(newDataList);
  };

  const handleDetailCancelLike = (id: number) => {
    if (curActiveItemIdx === null) return;
    const newDataList = cloneDeep(dataList);
    const newItem = newDataList[curActiveItemIdx];
    newItem.like -= 1;
    const newImgs = cloneDeep(newItem.opus_image);
    const imgIdx = newImgs.findIndex((item) => String(item.image_id) == String(id));
    newImgs[imgIdx].likes! -= 1;
    newImgs[imgIdx].is_like = false;
    newItem.opus_image = newImgs;
    setDataList(newDataList);
  };

  const handleItemClicked = async (info: ImgAndPromptItemType[], itemIdx: number) => {
    setCurActiveItemIx(itemIdx);
    // const imgIdx = dataList[itemIdx];
    setCurrentOpusId(dataList[itemIdx].opus_id);
    setCurrentImgId(info[0].image_id);
    // const {
    //   data: { list },
    // } = await getPromptDetail({ image_id: Number(info[0].image_id) });
    // setCurDetailInfo(list);

    setDetailVisible(true);
    const newDataList = cloneDeep(dataList);
    newDataList[itemIdx].look += 1;
    setDataList(newDataList);
  };

  const handleItemDelete = async (idx: number, id: number) => {
    onOpen();
    setCurDelItemInfo({
      id,
      idx,
    });
  };

  const handleDelete = async () => {
    if (!curDelItemInfo) return;
    const res = await delRelease({ del_type: 2, opus_id: curDelItemInfo.id });
    if (res.code == 0) {
      localDelete(curDelItemInfo.idx);
      onClose();
    }
  };

  const handleRefresh = async (type: 0 | 1) => {
    if (type === 0 && curActiveItemIdx !== null && dataList[curActiveItemIdx]) {
      const newList = [...dataList];
      newList.splice(curActiveItemIdx, 1);
      setDataList(newList);
    }
    // if (type === 1 && curActiveItemIdx !== null && dataList[curActiveItemIdx]) {
    //   const res = await mySpaceOpusDetail({ opus_id: Number(currentOpusId) });
    //   console.log("res: ", res);
    //   if (res.code === 0 && res.data && curActiveItemIdx !== null) {
    //     const newDataList = cloneDeep(dataList);
    //     newDataList[curActiveItemIdx] = res.data;
    //     setDataList(newDataList);
    //   }
    // }
  };

  return (
    <div className={styles["publish-wrapper"]}>
      <div
        className={styles["data-list-wrapper"]}
        style={{ gridTemplateColumns: `repeat(${column}, 1fr)` }}
      >
        {dataList.map((item, idx) => (
          <PubItem
            info={item}
            key={idx}
            idx={idx}
            handleDelete={handleItemDelete}
            handleItemClicked={handleItemClicked}
          />
        ))}
      </div>
      {!mySpaceStore.loading && !firstLoad && (
        <div className={styles["add-more-wrapper"]}>
          {!noMore && (
            <button onClick={handleLoadMore} className={styles["add-more-btn"]}>
              加载更多
            </button>
          )}
          {noMore && dataList.length > 0 && <div className={styles["no-more"]}>没有更多了</div>}
        </div>
      )}

      {dataList.length === 0 && !mySpaceStore.loading && !firstLoad && (
        <EmptyContent
          firstContent="您还没有发布任何作品"
          secondContent="前往工作站尽情发挥创意吧！"
        />
      )}
      {detailVisible && (
        <div className={styles["detail-wrapper"]}>
          <GalleryDetail
            currentID={Number(currentImgId)}
            opusId={Number(currentOpusId)}
            onClose={handleDetailClose}
            // previewList={curDetailInfo}
            onRefresh={handleRefresh}
            onLike={handleDetailLike}
            onCancelLike={handleDetailCancelLike}
          />
        </div>
      )}

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef as any}
        onClose={onClose}
        isOpen={isOpen}
        size={"3xl"}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent
          color={"#fff"}
          backgroundColor={"#27272A"}
          borderRadius={"20px"}
          paddingBottom={"34px"}
        >
          <AlertDialogCloseButton />
          <AlertDialogBody
            fontSize={"20px"}
            fontWeight={500}
            textAlign={"center"}
            marginBottom={"67px"}
            paddingTop={"90px"}
          >
            作品删除后将不可恢复😳您确定要删除吗?
          </AlertDialogBody>
          <div className={styles["footer-wrapper"]}>
            <button className={styles["footer-btn"]} onClick={onClose}>
              返回空间
            </button>
            <button
              className={`${styles["footer-btn"]} ${styles["dangerous"]}`}
              onClick={handleDelete}
            >
              狠心删除
            </button>
          </div>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default observer(Publish);
